import { useParams } from "react-router-dom";
import NewsCategoryPage from "./NewsCategoryPage";
import Newspage from "../Newspage";

export default function SearchSourceSwitch() {
  const { source } = useParams();
  
  if (source === "categories" || source === "rating" || source === "partner-publishers") {    
    return <Newspage />;
  }
  return <NewsCategoryPage />;
}
